import { crudSelectorsCustom } from 'redux/crudCreatorCustom/selector';
import { MODEL_NAME } from './actions';

export const providersOfMeBasicSelectors = crudSelectorsCustom(MODEL_NAME);
